/**
 * Maneja los clicks en variantes sin stock para mostrar el sidebar de "Notify Me"
 */
document.addEventListener('DOMContentLoaded', function() {

  // Función para obtener el nombre del producto actual
  function getCurrentProductName() {
    // Intentar obtener el nombre del producto desde .product__title h3
    const productTitleH3 = document.querySelector('.product__title h3');
    if (productTitleH3) {
      return productTitleH3.textContent.trim();
    }
    
    // Fallback: intentar otros selectores
    const productTitle = document.querySelector('.product__title, h1.product-title, [itemprop="name"]');
    if (productTitle) {
      return productTitle.textContent.trim();
    }
    
    // Fallback: obtener del meta tag
    const metaTitle = document.querySelector('meta[property="og:title"]');
    if (metaTitle) {
      return metaTitle.getAttribute('content');
    }
    
    return 'THIS PRODUCT';
  }

  // Función para obtener el Product ID
  function getCurrentProductId() {
    // Intentar obtener de diferentes lugares
    const productIdMeta = document.querySelector('meta[property="product:id"]');
    if (productIdMeta) {
      return productIdMeta.getAttribute('content');
    }
    
    // Buscar en el JSON del producto
    const productJson = document.querySelector('script[type="application/ld+json"]');
    if (productJson) {
      try {
        const data = JSON.parse(productJson.textContent);
        if (data.productID) {
          return data.productID;
        }
      } catch (e) {}
    }
    
    // Buscar en el form
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      const productIdInput = productForm.querySelector('[name="product-id"]');
      if (productIdInput) {
        return productIdInput.value;
      }
    }
    
    return null;
  }

  // Función para obtener el Variant ID real basado en las opciones seleccionadas
  function getVariantIdFromOptions(optionValue) {
    // Buscar el objeto product en el window
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      const product = window.ShopifyAnalytics.meta.product;
      if (product.variants) {
        // Buscar la variante que coincida con el option value
        const variant = product.variants.find(v => {
          return v.public_title && v.public_title.includes(optionValue);
        });
        if (variant) {
          return variant.id;
        }
      }
    }
    
    // Buscar en el select de variantes si existe
    const variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect) {
      const option = Array.from(variantSelect.options).find(opt => 
        opt.text.includes(optionValue)
      );
      if (option) {
        return option.value;
      }
    }
    
    return null;
  }

  // Función para cambiar TODOS los botones a "NOTIFY ME"
  function changeButtonToNotifyMe() {
    // Buscar TODOS los botones de "Add to Cart" (desktop y mobile)
    const addToCartButtons = document.querySelectorAll('.product-form__submit, button[name="add"]');
    
    addToCartButtons.forEach(function(addToCartButton) {
      // Guardar el HTML original completo si no está guardado
      if (!addToCartButton.dataset.originalHTML) {
        addToCartButton.dataset.originalHTML = addToCartButton.innerHTML;
        addToCartButton.dataset.originalText = addToCartButton.textContent.trim();
        console.log('Contenido original guardado:', addToCartButton.dataset.originalText);
      }
      
      // Cambiar solo el texto del span, manteniendo la estructura
      const span = addToCartButton.querySelector('span');
      if (span) {
        span.textContent = 'NOTIFY ME';
      } else {
        addToCartButton.textContent = 'NOTIFY ME';
      }
      
      addToCartButton.classList.add('notify-me-active');
      
      // Cambiar type a button y añadir onclick
      addToCartButton.setAttribute('type', 'button');
      addToCartButton.setAttribute('onclick', "if(window._klOnsite){window._klOnsite.push(['openForm', 'XL9h9u'])}else{console.log('Klaviyo not loaded')}");
    });
  }
  
  // Función para restaurar TODOS los botones a "ADD TO CART"
  function restoreAddToCartButton() {
    const buttons = document.querySelectorAll('.product-form__submit, button[name="add"]');
    
    buttons.forEach(function(button) {
      // Restaurar HTML original completo si existe
      if (button.dataset.originalHTML) {
        button.innerHTML = button.dataset.originalHTML;
        console.log('Botón restaurado con HTML original');
      } else {
        // Fallback: restaurar solo el texto
        const originalText = button.dataset.originalText || 'ADD TO CART';
        const span = button.querySelector('span');
        if (span) {
          span.textContent = originalText;
        } else {
          button.textContent = originalText;
        }
        console.log('Botón restaurado con texto:', originalText);
      }
      
      button.classList.remove('notify-me-active');
      delete button.dataset.originalHTML;
      
      // Restaurar type a submit y quitar onclick
      button.setAttribute('type', 'submit');
      button.removeAttribute('onclick');
    });
  }

  // Función para actualizar la URL con la variante seleccionada
  function updateUrlWithVariant(variantId) {
    const url = new URL(window.location);
    url.searchParams.set('variant', variantId);
    
    // Actualizar URL sin recargar la página
    window.history.replaceState({}, '', url);
    
    console.log('URL actualizada con variante:', variantId);
  }

  // Función para actualizar el input del formulario principal
  function updateMainFormVariant(variantId) {
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.value = variantId;
      variantInput.disabled = false; // Asegurar que no esté disabled
      console.log('Input del formulario actualizado con variante:', variantId);
    }
  }

  // Función para limpiar selecciones previas
  function clearPreviousSelections() {
    const allVariantInputs = document.querySelectorAll('.product-form__input input[type="radio"]');
    
    allVariantInputs.forEach(function(input) {
      input.checked = false;
      // NO restaurar disabled - dejar que las variantes sin stock sigan siendo clickeables
    });
    
    // NO remover la clase variant-out-of-stock - las variantes sin stock deben mantener su estilo
  }

  // Función para manejar el click en variantes SIN STOCK únicamente
  function handleOutOfStockVariantClick(event) {
    console.log("entro")
    const label = event.target.closest('label');
    const input = label ? label.previousElementSibling : null;
    const flag = label.classList.contains('variant-out-of-stock') || input.classList.contains('disabled');

    console.log(flag)
    
    if (!input || !flag) return;
    
    // Solo interceptar si es una variante sin stock
    event.preventDefault();
    event.stopPropagation();
    
    // Limpiar selecciones previas
    clearPreviousSelections();
    
    // Habilitar el input para que funcione
    input.disabled = false;
    input.classList.remove('disabled');
    
    // Marcar como seleccionado
    input.checked = true;
    
    // Añadir clase custom para mantener el estilo line-through
    label.classList.add('variant-out-of-stock');
      
    // Obtener el nombre del producto
    const productName = getCurrentProductName();
    
    // Obtener el valor de la variante (ej: "36")
    const variantValue = input.value;
    
    // Construir el nombre completo: "BLACK COCO ROXY BOOTS SIZE 36"
    const fullProductName = `${productName} SIZE ${variantValue}`;
    
    console.log('Producto sin stock:', fullProductName);
    
    // Obtener el valor de la opción (ej: "36")
    const optionValue = input.value;
    
    // Intentar obtener el Variant ID real
    let variantId = getVariantIdFromOptions(optionValue);
    
    // Si no se encuentra, usar el option value como fallback
    if (!variantId) {
      variantId = optionValue;
      console.warn('No se pudo encontrar el Variant ID real, usando option value:', variantId);
    }
    
    const productId = getCurrentProductId();
    console.log('Option Value:', optionValue, 'Variant ID:', variantId, 'Product ID:', productId);
    
    // Cambiar el botón a "NOTIFY ME"
    changeButtonToNotifyMe();

    // Forzar actualización de URL con la variante sin stock
    updateUrlWithVariant(variantId);
    
    // Actualizar el input del formulario principal
    updateMainFormVariant(variantId);
  }

  // Función para detectar cambios en variantes disponibles
  function handleAvailableVariantChange() {
    // Usar un pequeño delay para permitir que Shopify procese el cambio
    setTimeout(() => {
      const selectedVariant = document.querySelector('.product-form__input input[type="radio"]:checked');
      if (selectedVariant && !selectedVariant.classList.contains('disabled')) {
        console.log('Variante disponible seleccionada, restaurando botón');
        restoreAddToCartButton();
      }
    }, 100);
  }

  function handleActiveVariantOnLoad() {
    const selectedVariant = document.querySelector('.product-form__input input[type="radio"]:checked');
    const outOfStockflag = selectedVariant.classList.contains('disabled') || selectedVariant.classList.contains('variant-out-of-stock');
    
    if (selectedVariant && outOfStockflag) {
      changeButtonToNotifyMe();
      updateMainFormVariant(selectedVariant.value);
    }
  }

  // Agregar event listeners a todos los labels de variantes
  function attachListeners() {
    // Buscar todos los labels dentro de product-form__input
    const variantLabels = document.querySelectorAll('.product-form__input label');
    
    variantLabels.forEach(function(label) {
      // Remover listeners previos si existen
      label.removeEventListener('click', handleOutOfStockVariantClick);
      
      // Agregar listener solo para variantes sin stock
      label.addEventListener('click', handleOutOfStockVariantClick);
    });
    
    // Agregar listener para detectar cambios en variantes disponibles
    const variantInputs = document.querySelectorAll('.product-form__input input[type="radio"]');
    variantInputs.forEach(function(input) {
      input.removeEventListener('change', handleAvailableVariantChange);
      input.addEventListener('change', handleAvailableVariantChange);
    });
  }

  // Función para habilitar la primera variante si el producto está totalmente sin stock
  function enableFirstVariantIfAllSoldOut() {
    // Verificar si hay alguna variante disponible
    const availableVariants = document.querySelectorAll('.product-form__input input[type="radio"]:not(.disabled)');
    
    // Si no hay variantes disponibles, habilitar la primera sin stock
    if (availableVariants.length === 0) {
      const firstOutOfStockInput = document.querySelector('.product-form__input input[type="radio"].disabled');
      
      if (firstOutOfStockInput) {
        // Solo quitar la clase disabled para que se pueda seleccionar
        firstOutOfStockInput.classList.remove('disabled');
        
        // Obtener variant ID y actualizar URL
        const variantId = getVariantIdFromOptions(firstOutOfStockInput.value);
        if (variantId) {
          updateUrlWithVariant(variantId);
        }
        
        console.log('Primera variante sin stock habilitada y URL actualizada:', variantId);
      }
    }
  }

  // Inicializar listeners
  attachListeners();
  
  // Habilitar primera variante si todo está sin stock
  enableFirstVariantIfAllSoldOut();

  // Re-inicializar listeners si el contenido cambia (para páginas dinámicas)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        attachListeners();
      }
    });
  });

  // Observar cambios en el contenedor del producto
  const productContainer = document.querySelector('.product-form, .product, main');
  if (productContainer) {
    observer.observe(productContainer, {
      childList: true,
      subtree: true
    });
  }

  handleActiveVariantOnLoad();
});
